import classNames from 'classnames';
import * as React from 'react';

export interface IRightBannerProps {
    title: string;
    imgSrc: string;
    imgWidth?: number;
    imgHeight?: number;
    asNewWindow?: boolean;
    onClick: () => void;
}

export const RightBannerComponent: React.FC<IRightBannerProps> = (props: IRightBannerProps) => {
    return (
        <div className={classNames("right-banner-wrapper", __IsMTSTipos__ ? "mb-2" : "pt-2")}>
            <div className="header">{props.title}</div>
            <div className="right-banner-content">
                <a href="#" onClick={() => { props.onClick(); return false; }} target={props.asNewWindow ? "_blank" : undefined} title={props.title}><img src={props.imgSrc} style={{ maxWidth: "100%", height: "auto" }} /></a>
            </div>
        </div>)
};
